import React from 'react';
import { useNavigate } from 'react-router-dom';
import { isEmbedded } from '@globegroupe-data/auth-kit/browser';
import UserMenu from './UserMenu.js';
import useDarkMode from '../hooks/useDarkMode.js';

function Topbar({ currentUser, logout }) {
  // Before any early return: the theme applies inside an iframe too.
  const { darkMode, toggleDarkMode } = useDarkMode();
  // Même détection que le reste de l'app (auth-kit) : en iframe, pas de header ni
  // de bouton Déconnexion — le seul logout visible est celui de l'app parente.
  const isIframe = isEmbedded();
  const navigate = useNavigate();

  // If we're in an iframe, show nothing
  if (isIframe)
    return null;

  // 60px tall, edge-to-edge with a 28px gutter and sticky — the app shell of the
  // design. Deliberately not `container mx-auto`, which inset the brand from the
  // window edge on wide screens.
  return (
    <header className="sticky top-0 z-[69] h-[60px] border-b border-gray-200 bg-white shadow-sm dark:border-gray-900 dark:bg-[#141414] dark:shadow-md">
      <div className="flex h-full items-center justify-between px-4 sm:px-7">
        <button
          type="button"
          onClick={() => navigate('/')}
          className="flex items-center gap-3 rounded-lg outline-none transition-opacity hover:opacity-80"
        >
          <span
            className="inline-flex h-[30px] w-[30px] flex-none items-center justify-center rounded-[9px] bg-[#5b3df0] text-base font-bold text-white"
            aria-hidden
          >
            G
          </span>
          <span className="text-[19px] font-bold tracking-tight text-gray-900 dark:text-white">
            Globe Insights
          </span>
        </button>

        <UserMenu
          currentUser={currentUser}
          logout={logout}
          darkMode={darkMode}
          toggleDarkMode={toggleDarkMode}
        />
      </div>
    </header>
  );
}

export default Topbar;
